<template lang="html">
    <div>
        <app-layout :loading="loading">
            <div slot="title">Abonelik Raporları</div>
            <div slot="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="nav-active-border b-primary top box">
                            <div class="nav nav-md">
                                <router-link :to="{path: '/dashboards/subscription/total', query: {id: dashboardId}}" class="nav-link" active-class="active"><span class="fa fa-pie-chart"></span> Özet Rapor</router-link>
                                <router-link :to="{path: '/dashboards/subscription/operator', query: {id: dashboardId}}" class="nav-link" active-class="active"><span class="fa fa-pie-chart"></span> Operatör Raporu</router-link>
                                <router-link :to="{path: '/dashboards/subscription/mecra', query: {id: dashboardId}}" class="nav-link" active-class="active"><span class="fa fa-pie-chart"></span> Mecra Raporu</router-link>
                            </div>
                        </div>
                        <router-view />
                    </div>
                </div>
            </div>
        </app-layout>
    </div>
</template>

<script>
import AppLayout from '../../components/app_layout.vue';

export default {
    components: {
        'app-layout': AppLayout
    },
    data: function () {
        return {
            dashboardId: 0,
            loading: false
        }
    },
    created: function () {
        this.dashboardId = this.$router.currentRoute.query.id;
        if (this.$router.currentRoute.path == '/dashboards/subscription') {
            this.$router.push({path: '/dashboards/subscription/total', query: {id: this.dashboardId}});
        }
    },
    watch: {
        '$route': function (to, from) {
            if (to.path == '/dashboards/subscription') {
                this.$router.push({path: '/dashboards/subscription/total', query: {id: this.dashboardId}});
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// subscription.vue?9e12fc86